import { on } from 'delegated-events';

// Pole linku z ikoną kopiowania (.copy-link-field: input + button[data-copy-link]) — popup
// „Link do koszyka” w kroku 1 i strona „Twoje koszyki”. Popup powstaje dynamicznie, więc delegacja.
// Clipboard API wymaga bezpiecznego kontekstu; bez niego (albo przy odmowie) — zaznaczenie i execCommand.
const markCopied = (field) => {
    field.classList.add('copied');
    clearTimeout(field.copiedTimer);
    field.copiedTimer = setTimeout(() => field.classList.remove('copied'), 2000);
};

const copyFallback = (field, input) => {
    input.focus();
    input.select();
    input.setSelectionRange(0, input.value.length);

    try {
        if (document.execCommand('copy')) markCopied(field);
    } catch (e) {
        // link zostaje zaznaczony do skopiowania ręcznie
    }
};

export default function () {
    on('click', '.copy-link-field [data-copy-link]', e => {
        const field = e.currentTarget.closest('.copy-link-field');
        const input = field && field.querySelector('input');
        if (!input) return;

        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(input.value)
                .then(() => markCopied(field))
                .catch(() => copyFallback(field, input));
        } else {
            copyFallback(field, input);
        }
    });

    // Klik w pole zaznacza cały link — łatwo skopiować ręcznie (np. długie przytrzymanie na telefonie).
    on('focus', '.copy-link-field input[readonly]', e => {
        e.currentTarget.select();
    }, { capture: true });
}
